export const t = (obj: Object, key: string) => {
  const value = obj[key as keyof typeof obj];
  return value != null && typeof value !== "function" ? value : key;
}

export const getUserLang = () => {
  if (["cs", "en", "fr", "de", "hu", "it", "lv", "lt", "pl", "ro", "ru", "es", "uk"]
    .some(e => e === navigator.language.substring(0, 2))) { return navigator.language.substring(0, 2) }
  return "en";
}